import { logUsage, CustomData } from 'owa-analytics';

export default {
    CortanaComposeSearchTriggered: {
        datapoint: {
            name: 'CortanaComposeSearchTriggered',
            customData: (correlationId: string) => [correlationId],
        },
    },

    CortanaComposeInlineSearchOpened: {
        datapoint: {
            name: 'CortanaComposeInlineSearchOpened',
            customData: (correlationId: string) => [correlationId],
        },
    },

    CortanaComposeSearchDismissed: {
        datapoint: {
            name: 'CortanaComposeSearchDismissed',
            customData: (correlationId: string) => [correlationId],
        },
    },

    CortanaComposeSearchOptionSelected: {
        datapoint: {
            name: 'CortanaComposeSearchOptionSelected',
            customData: (correlationId: string) => [correlationId],
        },
    },

    CortanaComposeRuntimeExecuted: {
        datapoint: {
            name: 'CortanaComposeRuntimeExecuted',
            customData: (correlationId: string) => [correlationId],
        },
    },

    CortanaComposeFlexPaneOpened: {
        datapoint: {
            name: 'CortanaComposeFlexPaneOpened',
            customData: (correlationId: string, requiresUserInput: boolean) => [
                correlationId,
                requiresUserInput,
            ],
        },
    },

    CortanaComposeContentInserted: {
        datapoint: {
            name: 'CortanaComposeContentInserted',
            customData: (correlationId: string) => [correlationId],
        },
    },
};

export function logCortanaUsage(name: string, customData: CustomData) {
    // TODO: turn off isCore after expermiment (OW: 38471)
    logUsage(name, customData, { isCore: true });
}
